import { AppImages, React, variantProvider } from '@/app'
import { Button, Image, Text, View } from '@/components'
import { RenderItemProps } from './types'
import { assignTextStyle, useMemo } from '@codeleap/common'
import { openURL } from '@/utils'
import { DebugItem, FeedDimensions } from './shared'
import { TagType } from '../atoms/TagType'

const isValidImage = (img?: string) => !!img && img.trim() !== ''

export function FeedBetaGame(props: RenderItemProps) {
  const { item } = props

  const onPress = () => {
    openURL(item.game.url)
  }

  const image = useMemo(() => {
    if (isValidImage(item.game?.feed_img)) return item.game.feed_img
    if (isValidImage(item.game?.image)) return item.game.image
    return AppImages.GradientBackground
  }, [item.game])

  return (
    <>
      <DebugItem {...props} />

      <Image source={image} style={styles.backgroundImg} />

      <View variants={['paddingHorizontal:2', 'fullWidth']}>
        <View
          variants={['backgroundColor:neutral1', 'padding:2', 'gap:2', 'column', 'fullWidth']}
          style={{ borderRadius: 32, zIndex: 1 }}
        >
          <View variants={['row', 'alignCenter', 'justifySpaceBetween', 'fullWidth']}>
            <View variants={['row', 'alignCenter', 'gap:1']}>
              <TagType icon="game" />
              <Text variants={['h2']} text={item.game.name} />
            </View>
            {item.game?.beta_game ? <Text text={'Beta'} style={styles.betaGame} /> : null}
          </View>

          <Button text="Play now" debugName="play_hurdle_from_feed" onPress={onPress} />
        </View>
      </View>
    </>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    backgroundImg: {
      ...theme.presets.absolute,
      ...theme.presets.whole,
      width: FeedDimensions.WIDTH,
      height: FeedDimensions.HEIGHT,
      objectFit: 'cover',
      zIndex: 0,

      [theme.media.down(FeedDimensions.mobileBreakpoint)]: {
        width: FeedDimensions.WIDTH_WITHOUT_SPACING,
        height: FeedDimensions.HEIGHT_WITHOUT_SPACING
      }
    },
    betaGame: {
      backgroundColor: theme.colors.primary3,
      ...assignTextStyle('p2')(theme).text,
      color: theme.colors.neutral1,
      borderRadius: theme.borderRadius.small,
      ...theme.spacing.paddingHorizontal(0.75),
      ...theme.spacing.paddingVertical(0.375),
      ...theme.spacing.marginLeft(0.5),
      ...theme.spacing.marginVertical('auto')
    }
  }),
  true
)
